// src/pages/Account.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { useSubscription } from "../hooks/useSubscription";

export default function Account() {
  const { t } = useTranslation();
  const { subscription, loading } = useSubscription();

  if (loading) return <div className="p-6">{t("accountPage.loading")}</div>;

  const isTrialing = subscription?.status === "trialing";
  const isActive = ["active", "trialing"].includes(subscription?.status);
  const isPastDue = subscription?.status === "past_due";
  const isFrozen = subscription?.is_frozen;

  let daysLeft = null;
  if (isTrialing && subscription?.trial_end) {
    const end = new Date(subscription.trial_end);
    const milliseconds = end - new Date();
    if (milliseconds > 0) daysLeft = Math.ceil(milliseconds / 86400000);
  }

  const planLabel = subscription?.plan
    ? t(`accountPage.plans.${subscription.plan}`, { defaultValue: subscription.plan })
    : t("accountPage.plans.standard");
  const statusLabel = subscription?.status
    ? t(`accountPage.statuses.${subscription.status}`, { defaultValue: subscription.status })
    : "";

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">{t("accountPage.title")}</h1>

      {subscription ? (
        <div className="rounded-xl border border-gray-200 p-6 bg-white">
          <div className="mb-3"><span className="font-semibold">{t("accountPage.plan")}</span> {planLabel}</div>
          <div className="mb-3"><span className="font-semibold">{t("accountPage.status")}</span>{" "}<span>{statusLabel}</span></div>

          {isTrialing && daysLeft && (
            <div className="mt-3 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded px-3 py-2">
              {t("accountPage.trialActive", { count: daysLeft })}
            </div>
          )}

          {isActive && !isTrialing && <div className="text-green-700 mt-3">{t("accountPage.active")}</div>}

          {isPastDue && (
            <div className="mt-3 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded px-3 py-2">
              {t("accountPage.pastDue")}
            </div>
          )}

          {isFrozen && (
            <div className="mt-3 text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded px-3 py-2">
              {t("accountPage.frozen")}
            </div>
          )}

          <div className="mt-6 flex gap-3">
            <a href="/billing" className="btn-artsy btn-primary-artsy">{t("accountPage.manage")}</a>
            <a href="/invoices" className="btn-artsy btn-secondary-artsy">{t("accountPage.invoices")}</a>
          </div>
        </div>
      ) : (
        <div className="rounded-xl border border-gray-200 p-6 bg-white">
          <p className="mb-4">{t("accountPage.noSubscription")}</p>
          <a href="/pricing" className="btn-artsy btn-primary-artsy">{t("accountPage.choosePlan")}</a>
        </div>
      )}
    </div>
  );
}
